export default __webpack_public_path__ + "static/media/nesto-online-app4.c6ef354b.png";